// extracted by mini-css-extract-plugin
export default {"layoutScreen":"SharedLayout_layoutScreen__HP+ea","sidebar":"SharedLayout_sidebar__T1NYR","content":"SharedLayout_content__JWO54"};